import { FunctionComponent, memo } from 'react';
import './tab.scss';

// /**
//  * Компонент Tab для отображения табов
//  * @param {Object} props - Свойства компонента
//  * @param {string} props.text - Текст таба
//  * @param {boolean} props.isSelected - Выбран ли таб
//  * @param {function} props.onClick - Функция обратного вызова при клике
//  * @param {React.ReactNode} props.icon - Иконка для отображения в табе
//  * @param {string} props.className - Дополнительные классы CSS
//  */

export type TabProps = {
  text?: any;
  item?: any;
  isSelected?: any;
  onClick?: any;
  icon?: any;
  className?: any;
  isDisabled?: boolean;
};
export const Tab: FunctionComponent<TabProps> = memo(
  ({
    text,
    isSelected = false,
    onClick,
    icon = null,
    className = '',
    item,
    isDisabled,
  }) => {
    return (
      <button
        disabled={isDisabled}
        className={`tab ${isSelected ? 'tab_selected' : ''} ${className}`}
        onClick={onClick}
        data-quant={item}
      >
        {icon && <span className="tab_icon">{icon}</span>}
        {text}
      </button>
    );
  },
);

export default Tab;
